<div class="filterSection float-end">
  <div class="float-start mr2">
      <select class="form-select col-sm-3 " aria-label="Default select example"
          (change)="updateMonthListener($event)">
          <option *ngFor="let year of newsLettersDataList" [value]="year.id">
              <cbic-static-text [textEn]="year.titleEn" [textHi]="year.titleHi"></cbic-static-text>
          </option>
      </select>
  </div>
  <div class="float-start" *ngIf="monthList">
      <select class="form-select col-sm-3   " aria-label="Default select example"
          (change)="updateNewsLettersListener($event)">
          <option *ngFor="let month of monthList" [value]="month.id">
              <cbic-static-text [textEn]="month.titleEn" [textHi]="month.titleHi"></cbic-static-text>
          </option>
      </select>
  </div>
</div>
<div class="row chairmanData col-12 noPadding ">
  <div class="col-12 col-12 mt20  custom-scroll-bar                                                                                                                                                                                                                                                                                                                                       customizeHeight2 custom-scroll-bar " >
      <ul style="display: grid;gap: 10px; grid-template-columns: 1fr 1fr 1fr 1fr 1fr;" >
          <li  *ngFor="let news of newsletters" >
              <div class="card "> 
                  <div class="card-body ">
                    <div *ngFor="let new of news.cbicDocMsts">
                      <span class="col-12 noPadding">
                        <a class="btn btn-outline-secondary" (click)="ViewPdf(new.filePathEn)"> 
                            <img class="img-fluid" src="content/images/departmental-officers.svg"/>
                            <p class="card-text">
                                <cbic-static-text [textEn]="news.titleEn" [textHi]="news.titleHi"></cbic-static-text>
                                
                            </p>
                          
                        </a>
                        </span> 
                      
                        </div>
                     
                      <!-- <div *ngFor="let new of news.cbicDocMsts"> -->
                      
                      <!-- <a class="btn btn-outline-secondary" (click)="ViewPdf(new.filePathEn)">View More</a> -->
                  <!-- </div> -->
              </div>
              </div>

          </li>
      </ul>
     
  </div>
</div>